export const LEAD_STATUSES = [
  'NEW',
  'IN_PROGRESS',
  'NO_ANSWER',
  'CALL_AGAIN',
  'POTENTIAL',
  'RECALL',
  'NO_INTEREST',
  'NO_POTENTIAL',
] as const;

const LABELS: Record<(typeof LEAD_STATUSES)[number], string> = {
  NEW: 'New',
  IN_PROGRESS: 'In progress',
  NO_ANSWER: 'No answer',
  CALL_AGAIN: 'Call again',
  POTENTIAL: 'Potential',
  RECALL: 'Recall',
  NO_INTEREST: 'No interest',
  NO_POTENTIAL: 'No potential',
};

export function leadStatusLabel(status: string): string {
  return LABELS[status as keyof typeof LABELS] ?? status;
}
